import React from 'react';
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import { Form, Row, Col } from 'react-bootstrap';
import { googleLogin } from 'functions/userAuth';
import { useNavigate } from 'react-router-dom';

const SocialAuthButtons = ({ onGoogleSuccess, onGoogleFailure }) => {
  const navigate = useNavigate();
  // Handler for Google login success
  const handleGoogleSuccess = async (credentialResponse) => {
    // Decode JWT to get user email
    const base64Url = credentialResponse.credential.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    const user = JSON.parse(jsonPayload);
    if (user.email && !user.email.endsWith('@gmail.com')) {
      // Only allow corporate (non-gmail.com) users
      try {
        console.log(user.given_name);
        const res = await googleLogin(user.email);
        if (res.data && res.data.token) {
          // Add gmtOffset to userData just like normal login
          const gmtOffset = new Date().getTimezoneOffset().toString();
          const userWithGmt = { ...res.data.user, gmtOffset };
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('refreshToken', res.data.refreshToken);
          localStorage.setItem('userData', JSON.stringify(userWithGmt));
          // Successful login, you can redirect or show success
          if (onGoogleSuccess) onGoogleSuccess(user, credentialResponse.credential);
          navigate('/support-desk/table-view/1/0'); // Redirect to table view after successful Google auth
        } else {
          alert('No account found for this email. Please contact your administrator.');
          googleLogout();
        }
      } catch (err) {
        alert('No account found for this email. Please contact your administrator.');
        googleLogout();
      }
    } else {
      alert('Only corporate (non-@gmail.com) accounts are allowed.');
      googleLogout();
    }
  };

  // Handler for Google login failure
  const handleGoogleFailure = () => {
    if (onGoogleFailure) onGoogleFailure();
    alert('Google authentication failed.');
  };

  return (
    <Form.Group className="mb-0">
      <Row>
        <Col sm={12} className="mb-2">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleFailure}
            useOneTap
            width="100%"
            text="signin_with"
            shape="pill"
            theme="filled_black"
          />
        </Col>
      </Row>
    </Form.Group>
  );
};

export default SocialAuthButtons;
